import { SearchInput } from "@components/ui/SearchInput";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/shadcn-ui/select";
import { titleCase } from "./components/utils";
import CSVDownloadButton from "features/downloadCsv/DownloadToCsv";

interface ApplicationToolsProps {
  searchQuery: string;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedStatus: string | null;
  handleStatusChange: (status: string | null) => void;
  statuses: string[];
  applications?: any;
}

export const ApplicationTools = ({
  searchQuery,
  handleSearchChange,
  selectedStatus,
  handleStatusChange,
  statuses,
  applications = [],
}: ApplicationToolsProps) => (
  <div className="flex flex-wrap items-center gap-1 px-0">
    <SearchInput
      searchQuery={searchQuery}
      handleSearchChange={handleSearchChange}
      messages={[
        "Search application quickly...",
        "by customer name..",
        "Or by status..",
        "Or by application id..",
      ]}
    />
    <div className="h-12 w-full md:w-64">
      <Select
        value={selectedStatus || "all"}
        onValueChange={(value) =>
          handleStatusChange(value === "all" ? null : value)
        }
      >
        <SelectTrigger className="bg-white w-full min-h-full md:w-64 text-muted-foreground">
          <SelectValue placeholder="Filter by status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          {statuses.map((status) => (
            <SelectItem key={status} value={status}>
              {titleCase(status.replace(/_/g, " "))}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <CSVDownloadButton data={applications} filename='applications.csv' />
  </div>
);
